import { setTimeout, runOnReadyState, clearTimeout, mockable } from '@datadog/browser-core';
import { getNavigationEntry, sanitizeFirstByte } from '../../../browser/performanceUtils';
export function trackNavigationTimings(configuration, callback) {
  return waitAfterLoadEvent(configuration, function () {
    var entry = mockable(getNavigationEntry)();
    if (!isIncompleteNavigation(entry)) {
      callback(processNavigationEntry(entry));
    }
  });
}
function processNavigationEntry(entry) {
  return {
    domComplete: entry.domComplete,
    domContentLoaded: entry.domContentLoadedEventEnd,
    domInteractive: entry.domInteractive,
    loadEvent: entry.loadEventEnd,
    firstByte: sanitizeFirstByte(entry)
  };
}
function isIncompleteNavigation(entry) {
  return entry.loadEventEnd <= 0;
}
function waitAfterLoadEvent(configuration, callback) {
  var timeoutId;
  var _runOnReadyState = runOnReadyState(configuration, 'complete', function () {
      // Invoke the callback a bit after the actual load event, so the "loadEventEnd" timing is accurate
      timeoutId = setTimeout(function () {
        return callback();
      });
    }),
    stopOnReadyState = _runOnReadyState.stop;
  return {
    stop: function stop() {
      stopOnReadyState();
      clearTimeout(timeoutId);
    }
  };
}